// removed by extract-text-webpack-plugin
module.exports = {"button":"IconButton__button___1b1_1"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/views/widgets/IconButton.css
 ** module id = 712
 ** module chunks = 0
 **/